import React, {PureComponent, createRef} from "react";
import styles from './FJResourceElementMore.module.less';
import classNames from 'classnames';
import FJToolContent from 'fj-components/FJToolContent'
import FJPageHeaderBack from 'fj-components/FJPageHeaderBack'
import FJCustomScroll from 'fj-components/FJCustomScroll'
import FJFixedLayout from 'fj-components/FJFixedLayout'
import FJResourcesElementCommon from './FJResourcesElementCommon'
import FJCoreUtil from "../../../core/util/FJCoreUtil";

class FJResourceElementMore extends PureComponent{

	constructor(props) {
		super(props);
		this.scrollRef = createRef();
	}

	_getCollectionList = () => {
		let {
			resourceViewInfo,
			list,
			onAddClick,
			onHandleClick,
			onMediaDrag,
			classes,
			config,
			allTooltip,
			toggleTooltip,
			oneTooltip,
			chooseMediaIdList
		} = this.props;

		let {
			width,
			height,
			space,
			marginBottom,
			marginLeft = 0
		} = resourceViewInfo;

		let {
			addIcon,
			deleteIcon,
			activeColor,
			addIconToolTip,
		} = config;

		return <FJFixedLayout
			basicWidth={width}
			space={space}
			active={list.length}
			render={(itemWidth, space, column) => {
				let itemHeight = height;
				return list.map((item, index) => (
					<FJResourcesElementCommon
						key={item.id}
						id={item.id}
						width={itemWidth}
						height={itemHeight}
						marginRight={(index + 1) % column === 0 ? 0 : space}
						marginBottom={marginBottom}
						marginLeft={marginLeft}
						thumbnail={item.thumbnail}
						url={item.url}
						name={item.title}
						hasName={false}
						type={item.type}
            fromType={item.fromType}
						hasAddBtn
						onAddClick={onAddClick}
						selectMedia={onHandleClick}
						classes={classes.itemClasses}
            contentClassName={styles.item_content}
						activeColor={activeColor}
						addIcon={addIcon}
						deleteIcon={deleteIcon}
						onMediaDrag={onMediaDrag}
						addIconToolTip={addIconToolTip}
						allTooltip={allTooltip}
						toggleTooltip={toggleTooltip}
						oneTooltip={oneTooltip}
						isChoose={chooseMediaIdList.indexOf(item.id) !== -1}
						authorItem={item.authorItem}
					/>
				))
			}}
		/>
	}

	/**
	 * @description 将滚动条置顶
	 * @private
	 */
	_scrollToTop = () => {
		if (this.props.backElement) {
			this.props.backElement();
		}
		if (this.scrollRef.current.getScrollTop() > 0) {
			this.scrollRef.current.scrollTop(0, true)
		}
	}

	_onScroll = () => {
    FJCoreUtil.triggerBodyMousedown()
  };

	_render = () => {
    let {classes} = this.props
	  return (
      <div className={ classNames(styles.inner, classes.textMoreInnerBox) }>
        {this._getCollectionList()}
      </div>
    );
  };

	render() {
		let {isShow, backTitle, title, classes} = this.props
		return (
			<div className={classNames(styles.more_box, {[styles.shown]: isShow})}>
				<FJToolContent active>
					<FJPageHeaderBack onClick={this._scrollToTop} backText={backTitle} title={title} classes={classes.pageHeaderBackClasses}>
						<div className={styles.clint_box}>
							<FJCustomScroll ref={this.scrollRef}
                              classes={classes.scrollClasses}
                              render={this._render}
                              onScroll={this._onScroll} />
						</div>
					</FJPageHeaderBack>
				</FJToolContent>
			</div>
		)
	}

}

export default FJResourceElementMore;